module.exports = __webpack_public_path__ + "static/media/points8_3.9f4250f8.png";